import { ComponentRef, TemplateRef } from '@angular/core';
import { ControlType } from '../types/control.types';

export interface INamedTemplateDirective {
  template: TemplateRef<unknown>;
  name: string;
  scope?: string;
}

export interface ISchemaInput {
  name: string;
  label?: string;
  type: string;
  partOf?: string;
  value: unknown;
  options?: Array<{ key: unknown; value: unknown }> | undefined;
  group?: string;
  order?: number;
}

export interface ISchemaOutput {
  name: string;
  callback: string;
}

export interface ISchemaAttribute {
  name: string;
  value: string;
}

export interface ISchemaControl {
  uid: string;
  type: ControlType | undefined;
  cmpRef?: ComponentRef<any>;
  inputs?: Array<ISchemaInput>;
  outputs?: Array<ISchemaOutput>;
  attributes?: Array<ISchemaAttribute>;
  items?: Array<ISchemaControl>;
  parent?: ISchemaControl;
  isLazy?: boolean;
}

export function resolveSchemaStructureOperation(
  source: any,
  target: any,
  operator: '===' | '!==' | 'includes' | '!includes',
) {
  switch (operator) {
    case '===':
      return source === target;
    case '!==':
      return source !== target;
    case 'includes':
      return target.includes(source);
    case '!includes':
      return !target.includes(source);
  }
}
